import { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-teal-600">AquaClean Pro</h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('why-choose')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('booking')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
              Book Now
            </button>
            <a href="tel:+61475854327" className="flex items-center gap-2 text-teal-600 hover:text-teal-700 transition-colors font-semibold">
              <Phone size={18} />
              <span>+61 475 854 327</span>
            </a>
            <a href="/admin" className="text-xs text-gray-400 hover:text-teal-600 transition-colors">
              •
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left">
                Home
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left">
                Services
              </button>
              <button onClick={() => scrollToSection('why-choose')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left">
                About
              </button>
              <button onClick={() => scrollToSection('booking')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium text-left">
                Book Now
              </button>
              <a href="tel:+61475854327" className="flex items-center gap-2 text-teal-600 hover:text-teal-700 transition-colors font-semibold">
                <Phone size={18} />
                <span>+61 475 854 327</span>
              </a>
              <a href="/admin" className="text-xs text-gray-400 hover:text-teal-600 transition-colors">
                Admin Access
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
